var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"pais","rota-base":"/admin/pais","titulo":"PAÍSES","titulo-singular":"País","colunas-extras":[
        { campo: "nacionalidade", label: "Nacionalidade", tipo: "string" },
        { campo: "ddi", label: "DDI", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }